import { useAtom } from '@reatom/npm-react'
import React from 'react'

import { CurrencyIcon } from '@root/entities/currency/ui/currency-icon'

import type { PairModel } from '@root/entities/pair/atoms'
import type { CurrencyIconPopoverProps } from '@root/features/currency/ui'

type PairIconProps = {
  pair: PairModel
  size?: number
  providerSize?: number
  outlined?: boolean
  withNetwork?: boolean
  withGoogleLens?: boolean
  withPremiumFallback?: boolean
  /**
   * @default true
   */
  withPreview?: boolean
  withMigration?: boolean
  onClick?: () => void
  reusedImages?: CurrencyIconPopoverProps['reusedImages']
  withPairPopover?: boolean
  iconSrcOverride?: string
}

export const PairIcon: React.FC<PairIconProps> = React.memo(
  ({
    pair,
    size = 30,
    providerSize,
    outlined = true,
    withNetwork = false,
    withPremiumFallback = true,
    withGoogleLens = true,
    withPreview = true,
    withMigration = false,
    withPairPopover = false,
    onClick,
    reusedImages,
    iconSrcOverride,
  }) => {
    const [premium] = useAtom(pair.premiumInfo.premium)
    const [migration] = useAtom(pair.migrationStatus)

    return (
      <CurrencyIcon
        currency={pair.quote}
        size={size}
        withNetwork={withNetwork}
        withPremiumFallback={withPremiumFallback}
        withGoogleLens={withGoogleLens}
        withPreview={withPreview}
        migration={withMigration ? migration : undefined}
        provider={pair.provider}
        auxIconSize={providerSize}
        outline={(() => {
          if (!outlined) {
            return undefined
          }
          return premium ? 'premium' : 'outline'
        })()}
        shape="rounded"
        onClick={onClick}
        premiumInfo={pair.premiumInfo}
        reusedImages={reusedImages}
        pairAddress={withPairPopover ? pair.address : undefined}
        iconSrcOverride={iconSrcOverride}
      />
    )
  },
)
